export function Share({ className = "fill-current" }) {
  return (
    <svg
      viewBox="0 0 19 20"
      xmlns="http://www.w3.org/2000/svg"
      className={className}>
      <path
        d="M15.5 14.08C14.74 14.08 14.06 14.38 13.54 14.85L6.41 10.7C6.46 10.47 6.5 10.24 6.5 10C6.5 9.76 6.46 9.53 6.41 9.3L13.46 5.19C14 5.69 14.71 6 15.5 6C17.16 6 18.5 4.66 18.5 3C18.5 1.34 17.16 0 15.5 0C13.84 0 12.5 1.34 12.5 3C12.5 3.24 12.54 3.47 12.59 3.7L5.54 7.81C5 7.31 4.29 7 3.5 7C1.84 7 0.5 8.34 0.5 10C0.5 11.66 1.84 13 3.5 13C4.29 13 5 12.69 5.54 12.19L12.66 16.35C12.61 16.56 12.58 16.78 12.58 17C12.58 18.61 13.89 19.92 15.5 19.92C17.11 19.92 18.42 18.61 18.42 17C18.42 15.39 17.11 14.08 15.5 14.08ZM15.5 2C16.05 2 16.5 2.45 16.5 3C16.5 3.55 16.05 4 15.5 4C14.95 4 14.5 3.55 14.5 3C14.5 2.45 14.95 2 15.5 2ZM3.5 11C2.95 11 2.5 10.55 2.5 10C2.5 9.45 2.95 9 3.5 9C4.05 9 4.5 9.45 4.5 10C4.5 10.55 4.05 11 3.5 11ZM15.5 18.02C14.95 18.02 14.5 17.57 14.5 17.02C14.5 16.47 14.95 16.02 15.5 16.02C16.05 16.02 16.5 16.47 16.5 17.02C16.5 17.57 16.05 18.02 15.5 18.02Z"
        fill="black"
      />
    </svg>
  )
}
